import React from 'react';
import PropTypes from 'prop-types';
import { CoreCardGroup } from 'components/core/library/card';

/**
 * Styled group of cards, either in a row or a column. Extends [CoreCardGroup](#corecardgroup).
 */
export default function CardGroup({ children, direction }) {
	return <CoreCardGroup className={direction}>{children}</CoreCardGroup>;
}

CardGroup.propTypes = {
	children: PropTypes.node,
	/** Determiens the flex-direction of the items in the card. */
	direction: PropTypes.oneOf(['row', 'column']),
};

CardGroup.defaultProps = {
	direction: 'row',
};
